<template>
  <div>
    <toolbar />
    <mainView />
  </div>
</template>

<script>
import toolbar from "./../../components/structure/toolbar.vue";
import mainView from "./mainView.vue";
import { mapState } from "vuex";

export default {
  components: {
    toolbar,
    mainView
  },
  computed: {
    ...mapState(["app", "menu"])
  }
};
</script>

<style>
html,
body,
div.application,
div.application--wrap,
div.v-main__wrap,
main {
  padding: 0 !important;
  margin: 0 !important;
}
#mainView,
.fitContainer {
  overflow-y: auto !important;
  overflow-x: hidden !important;
  width: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
}
</style>